import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

interface DemoStatus {
  has_demo_data: boolean;
  counts: { packages: number; labor_cos: number; work_items: number; engagements: number; bids: number; discussions: number };
}

export function DemoDataPanel() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['demo-status'], queryFn: () => api<DemoStatus>('/demo/status') });
  const has = data?.has_demo_data ?? false;
  const c = data?.counts;

  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ['demo-status'] });
    qc.invalidateQueries({ queryKey: ['packages'] });
  };
  const seed = useMutation({ mutationFn: () => api('/demo/seed', { method: 'POST', body: '{}' }), onSuccess: invalidate });
  const clear = useMutation({ mutationFn: () => api('/demo/clear', { method: 'POST', body: '{}' }), onSuccess: invalidate });

  return (
    <div className="card" style={{ background: has ? '#fff8ec' : '#fff', borderColor: has ? '#d4a657' : 'var(--rule)' }}>
      <div className="row-wrap">
        <div style={{ flex: '1 1 300px' }}>
          <strong>演示数据 / Demo Data — D Hotel</strong>
          <div className="muted small" style={{ marginTop: 4 }}>
            {has
              ? <>✓ 已加载 / loaded · {c?.packages} 包 / package · {c?.labor_cos} 劳务方 / contractors · {c?.bids} 报价 / bids · {c?.discussions} 讨论 / comments</>
              : <>加载真实的 D Hotel 议价案例（谭江平 vs 江卫春，3 轮报价，¥1,300,000 测算价），清标自动运行。/ Load the real D-Hotel case (谭江平 vs 江卫春, 3 rounds, ¥1.3M envelope); cleaning runs automatically.</>}
          </div>
        </div>
        <div className="row">
          {!has && <button className="btn-primary" disabled={seed.isPending} onClick={() => seed.mutate()}>{seed.isPending ? '加载中…' : '+ 加载演示数据 / Load Demo'}</button>}
          {has && <button disabled={clear.isPending} onClick={() => { if (confirm('清除演示数据？/ Clear demo data?')) clear.mutate(); }}>{clear.isPending ? '清除中…' : '🗑 清除 / Clear'}</button>}
        </div>
      </div>
      {(seed.isError || clear.isError) && <div className="small" style={{ color: 'var(--bad)', marginTop: 8 }}>{String((seed.error || clear.error as any)?.message)}</div>}
    </div>
  );
}
